import { render, staticRenderFns } from "./itemedit.vue?vue&type=template&id=f268559a&"
import script from "./itemedit.vue?vue&type=script&lang=js&"
export * from "./itemedit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports